import { FetchAvailableOptionsTickers } from "../Apis/FetchAvailableOptionsTickers";
import { fetchTickerData } from "../Utilities/tickerUtils";

export const FETCH_AVAILABLE_OPTIONS_TICKERS_START = 'FETCH_AVAILABLE_OPTIONS_TICKERS_START';
export const FETCH_AVAILABLE_OPTIONS_TICKERS_SUCCESS = 'FETCH_AVAILABLE_OPTIONS_TICKERS_SUCCESS';
export const FETCH_AVAILABLE_OPTIONS_TICKERS_FAILURE = 'FETCH_AVAILABLE_OPTIONS_TICKERS_FAILURE';

export const fetchAvailableOptionsTickers = () => async (dispatch) => {
    const actionTypes = {
        START: FETCH_AVAILABLE_OPTIONS_TICKERS_START,
        SUCCESS: FETCH_AVAILABLE_OPTIONS_TICKERS_SUCCESS,
        FAILURE: FETCH_AVAILABLE_OPTIONS_TICKERS_FAILURE
    };
    
    return fetchTickerData(FetchAvailableOptionsTickers, dispatch, actionTypes);
};
